import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/**
 * Paie / bulletin — feuille de paie avec symbole € (jamais $, on est en France).
 */
export const PayrollIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Pastille € menthe */}
      <circle cx="16.5" cy="16" r="4.5" fill="var(--equiply-icon-bg)" />
      <path
        d="M18.5 14a2 2 0 0 0-3.25 1.8 2 2 0 0 0 3.25 1.8M14.5 15.4h2.5M14.5 16.4h2"
        stroke="hsl(var(--background))" strokeWidth="1.2" strokeLinecap="round"
      />
      {/* Document */}
      <path
        d="M5 3.5h7l4 4v6.5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      <path
        d="M5 3.5A1.5 1.5 0 0 0 3.5 5v15A1.5 1.5 0 0 0 5 21.5h6"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Coin replié */}
      <path
        d="M12 3.5V6a1.5 1.5 0 0 0 1.5 1.5H16"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Lignes */}
      <path
        d="M6.5 10.5h4M6.5 13.5h3"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  ),
);
PayrollIcon.displayName = "PayrollIcon";
